import { render, staticRenderFns } from "./documents.accountspayable.foreign.vue?vue&type=template&id=058623b1&scoped=true"
import script from "./documents.accountspayable.foreign.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.foreign.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.foreign.vue?vue&type=style&index=0&id=058623b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058623b1",
  null
  
)

export default component.exports